import { render, staticRenderFns } from "./BaseWrapper.vue?vue&type=template&id=c2e77130&scoped=true"
import script from "./BaseWrapper.vue?vue&type=script&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&lang=js"
import style0 from "./BaseWrapper.vue?vue&type=style&index=0&id=c2e77130&prod&lang=scss&scoped=true"
import style1 from "./BaseWrapper.vue?vue&type=style&index=1&id=c2e77130&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e77130",
  null
  
)

export default component.exports